/**
 * API matrice d'éligibilité plateforme × œuvre (S5.5).
 *
 * 3 endpoints (GET liste rules, GET liste blocking_tags, PATCH bulk
 * unifié) + 1 preview par œuvre (GET /works/{id}/eligibility).
 * Cf. `backend/app/api/eligibility.py`.
 */

import type {
  BlockingTagResponse,
  EligibilityBulkUpdateRequest,
  EligibilityBulkUpdateResponse,
  EligibilityRuleResponse,
  WorkEligibilityPreview,
} from '@/types/eligibility'

import { apiClient } from './client'

export const eligibilityApi = {
  listRules: async (): Promise<EligibilityRuleResponse[]> => {
    const { data } = await apiClient.get<EligibilityRuleResponse[]>('/eligibility/rules')
    return data
  },

  listBlockingTags: async (): Promise<BlockingTagResponse[]> => {
    const { data } = await apiClient.get<BlockingTagResponse[]>('/eligibility/blocking-tags')
    return data
  },

  /**
   * PATCH bulk atomique : applique tous les changements (rules updates +
   * blocking_tags insert/patch/delete) en une seule UoW. Retourne la
   * matrice rechargée pour rafraîchir le FE sans 2ème GET.
   */
  patchBulk: async (
    payload: EligibilityBulkUpdateRequest,
  ): Promise<EligibilityBulkUpdateResponse> => {
    const { data } = await apiClient.patch<EligibilityBulkUpdateResponse>('/eligibility', payload)
    return data
  },

  getWorkEligibility: async (workId: number): Promise<WorkEligibilityPreview> => {
    const { data } = await apiClient.get<WorkEligibilityPreview>(`/works/${workId}/eligibility`)
    return data
  },
}
